"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MembersList = exports.getPositive = exports.useGetMemberListMode = exports.useIsWidthDown = exports.useIsWidthUp = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const frontend_infra_localisation_1 = require("@forto-dev/frontend-infra-localisation");
const silhouette_core_1 = require("@freighthub/silhouette-core");
const lodash_es_1 = require("lodash-es");
const models_1 = require("../../../models");
const Actors_1 = require("../types/Actors");
const Subscription_1 = require("../types/Subscription");
const MemberItem_1 = require("./MemberItem");
const MoreMembers_1 = require("./MoreMembers");
const useStyles = (0, silhouette_core_1.makeStyles)((theme) => ({
    memberListContainer: {
        display: 'flex',
        maxWidth: '675px',
        flexWrap: 'wrap',
        margin: '0 auto',
    },
    plusButton: {
        backgroundColor: 'transparent',
        border: `1px solid ${theme.palette.grey['500']}`,
        width: '40px',
        height: '40px',
        borderRadius: '50%',
    },
}));
const useIsWidthUp = (breakpoint) => {
    const theme = (0, silhouette_core_1.useTheme)();
    return (0, silhouette_core_1.useMediaQuery)(theme.breakpoints.up(breakpoint));
};
exports.useIsWidthUp = useIsWidthUp;
const useIsWidthDown = (breakpoint) => {
    const theme = (0, silhouette_core_1.useTheme)();
    return (0, silhouette_core_1.useMediaQuery)(theme.breakpoints.down(breakpoint));
};
exports.useIsWidthDown = useIsWidthDown;
const useGetMemberListMode = () => {
    const isMdDown = (0, exports.useIsWidthDown)('md');
    const isSmUp = (0, exports.useIsWidthUp)('sm');
    const isSmDown = (0, exports.useIsWidthDown)('sm');
    if (isMdDown && isSmUp) {
        return Subscription_1.MEMBERS_LIST_COMPACT;
    }
    if (isSmDown) {
        return Subscription_1.MEMBERS_LIST_SUPER_COMPACT;
    }
    return Subscription_1.MEMBERS_LIST_EXPANDED;
};
exports.useGetMemberListMode = useGetMemberListMode;
const getPositive = (num) => {
    return num > 0 ? num : 0;
};
exports.getPositive = getPositive;
const MembersList = ({ subscriptionType, entityType, subscription, removeSubscriber, openDialog, disableModifySubscribers, displayMode, }) => {
    const { translate } = (0, frontend_infra_localisation_1.useI18n)();
    const classes = useStyles();
    const { actors, subscriptions } = subscription;
    const { users, forties } = actors;
    const contacts = subscriptions[0]?.contacts || [];
    const mode = (0, exports.useGetMemberListMode)();
    const { numberOfActors } = Subscription_1.breakpointMap[mode];
    const extraActorsNumber = (0, exports.getPositive)(contacts.length + users.length + forties.length - numberOfActors);
    const contactsLengthToDisplay = contacts.length < numberOfActors ? contacts.length : numberOfActors;
    const remainingLengthToDisplay = numberOfActors - contactsLengthToDisplay;
    const usersLengthToDisplay = remainingLengthToDisplay < users.length ? remainingLengthToDisplay : users.length;
    const fortiesLengthToDisplay = numberOfActors - contactsLengthToDisplay - usersLengthToDisplay;
    const displayName = displayMode === 'withNames';
    return ((0, jsx_runtime_1.jsxs)("div", { className: classes['memberListContainer'], children: [(0, lodash_es_1.take)(contacts, contactsLengthToDisplay).map((contact) => ((0, jsx_runtime_1.jsx)(MemberItem_1.MemberItem, { actor: contact, idType: Actors_1.CONTACT_ID, disabled: subscriptionType === models_1.SubscriptionType.USERS, removeSubscriber: removeSubscriber, displayName: displayName }, contact.id))), (0, lodash_es_1.take)(users, usersLengthToDisplay).map((user) => ((0, jsx_runtime_1.jsx)(MemberItem_1.MemberItem, { actor: user, idType: Actors_1.USER_ID, removeSubscriber: removeSubscriber, disabled: users.length === 1, displayName: displayName }, user.id))), (0, lodash_es_1.take)(forties, fortiesLengthToDisplay).map((fortie) => ((0, jsx_runtime_1.jsx)(MemberItem_1.MemberItem, { actor: fortie, idType: Actors_1.FORTIE_ID, disabled: subscriptionType === models_1.SubscriptionType.USERS || forties.length === 1, removeSubscriber: removeSubscriber, displayName: displayName }, fortie.id))), extraActorsNumber > 0 && (0, jsx_runtime_1.jsx)(MoreMembers_1.MoreMembers, { moreNumber: extraActorsNumber }), !disableModifySubscribers && ((0, jsx_runtime_1.jsx)(silhouette_core_1.Box, { width: displayName ? 60 : 44, display: "flex", justifyContent: "center", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.Tooltip, { title: translate('members-list-add_more'), placement: "bottom", children: (0, jsx_runtime_1.jsx)(silhouette_core_1.IconButton, { className: classes['plusButton'], onClick: openDialog, "data-tracking-id": `${entityType}-subscribers-add`, children: (0, jsx_runtime_1.jsx)(silhouette_core_1.AddIcon, {}) }) }) }))] }));
};
exports.MembersList = MembersList;
//# sourceMappingURL=MembersList.js.map